<div class="row">
    <div class="col-md-12 mb-md-0">
        <form #contactUs="ngForm" id="{{aWidgetParams.name}}_form" class="needs-validation"
            (ngSubmit)="contactUs.form.valid && submitContactUsForm(contactUs)">
            <div class="row">
                <div class="col-md-6">
                    <div class="form-group mb-2 form_input">
                        <label for="your_fname">{{aContactUsLangData.f_name}}</label>
                        <input #firstname="ngModel" [(ngModel)]="currentUsersFeedback.sFName" type="text"
                            class="form-control" name="firstname" placeholder="{{aContactUsLangData.f_name_c}}"
                            [ngClass]="{ 'is-invalid': contactUs.submitted && firstname.invalid }" required />
                        <div class="invalid-feedback" *ngIf="contactUs.submitted && firstname.invalid">
                            <div *ngIf="firstname.errors.required">{{aContactUsLangData.f_name_inval}}</div>
                        </div>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="form-group mb-2 form_input">
                        <label for="your_lname">{{aContactUsLangData.l_name}}</label>
                        <input #lastname="ngModel" [(ngModel)]="currentUsersFeedback.sLName" type="text"
                            class="form-control" name="lastname" placeholder="{{aContactUsLangData.l_name_c}}" />
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-md-7">
                    <div class="form-group mb-2 form_input">
                        <label for="your_email">{{aContactUsLangData.email}}</label>
                        <input #email="ngModel" [(ngModel)]="currentUsersFeedback.sEmail" type="email"
                            class="form-control" name="email" placeholder="{{aContactUsLangData.email_c}}"
                            [ngClass]="{ 'is-invalid': contactUs.submitted && email.invalid }" required />
                        <div class="invalid-feedback" *ngIf="contactUs.submitted && email.invalid">
                            <div *ngIf="email.errors.required">{{aContactUsLangData.email_inval}}</div>
                        </div>
                    </div>
                </div>
                <div class="col-md-5">
                    <div class="form-group mb-2 form_input">
                        <label for="your_phone">{{aContactUsLangData.phone}}</label>
                        <input #phone="ngModel" [(ngModel)]="currentUsersFeedback.sPhone" type="text"
                            class="form-control" name="phone" placeholder="{{aContactUsLangData.phone_c}}" />
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-md-8">
                    <div class="form-group mb-2 form_input">
                        <label for="subject">{{aContactUsLangData.subject}}</label>
                        <input #subject="ngModel" [(ngModel)]="currentUsersFeedback.sSubject" type="text"
                            class="form-control" name="subject" placeholder="{{aContactUsLangData.subject_c}}"
                            [ngClass]="{ 'is-invalid': contactUs.submitted && subject.invalid }" required />
                        <div class="invalid-feedback" *ngIf="contactUs.submitted && subject.invalid">
                            <div *ngIf="subject.errors.required">{{aContactUsLangData.subject_inval}}</div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-md-12">
                    <div class="form-group mb-2 form_input">
                        <label for="message">{{aContactUsLangData.text}}</label>
                        <textarea #message="ngModel" [(ngModel)]="currentUsersFeedback.sMessage" type="text"
                            class="form-control md-textarea" name="message" placeholder="{{aContactUsLangData.text_c}}"
                            rows="4" [ngClass]="{ 'is-invalid': contactUs.submitted && message.invalid }"
                            required></textarea>
                        <div class="invalid-feedback" *ngIf="contactUs.submitted && message.invalid">
                            <div *ngIf="message.errors.required">{{aContactUsLangData.text_inval}}</div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-md-12">
                    <div class="form-group mb-2">
                        <div #recaptcha></div>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-md-12">
                    <div class="form-group mb-2 form_btn">
                        <button class="btn btn-primary">{{aContactUsLangData.send}}</button>
                    </div>
                </div>
            </div>

        </form>
    </div>
</div>
